export const TRIGGER_UPDATE_SIDEBAR = 'sidebar/TRIGGER_UPDATE_SIDEBAR';
export const UPDATE_SIDEBAR = 'sidebar/UPDATE_SIDEBAR';

export function triggerUpdateSidebar(payload = {}) {
  return {
    type: TRIGGER_UPDATE_SIDEBAR,
    payload,
  };
}

export function updateSidebar(payload = {}) {
  return {
    type: UPDATE_SIDEBAR,
    payload
  };
}
